import { http } from '@/shared/api/http';
import type { User } from '@/shared/api/types';

export const authApi = {
  me: async () => (await http.get<User>('/auth/me')).data,
  login: async (email: string, password: string) => (await http.post<User>('/auth/login', { email, password })).data,
  logout: async () => { await http.post('/auth/logout'); },
  changePassword: async (current_password: string, new_password: string) => { await http.post('/auth/password', { current_password, new_password }); },
};
